import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Lock, Droplets, List } from 'lucide-react';
const visibleRecipes = [{
  title: 'Pomada para quemaduras leves',
  purpose: 'Ayuda a calmar la piel irritada y favorece la regeneración de la piel en quemaduras superficiales.'
}, {
  title: 'Pomada cicatrizante natural',
  purpose: 'Ayuda a estimular la regeneración de la piel en pequeñas heridas o cortes superficiales.'
}];
const lockedRecipes = ['Pomada para irritaciones de la piel', 'Pomada para dolores musculares', 'Pomada para picaduras de insectos', 'Pomada para piel seca o agrietada'];
export function RecipeTeaser() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <SectionWrapper id="recetas" className="px-4 md:px-12 max-w-6xl mx-auto" data-id="element-160">
      <div className="text-center mb-16" data-id="element-161">
        <h2 className="text-3xl md:text-5xl font-playfair text-forest mb-6" data-id="element-162">
          6 Recetas Naturales Incluidas
        </h2>
        <p className="text-lg text-brown/80 max-w-2xl mx-auto" data-id="element-163">
          Fórmulas exactas y probadas para que comiences a crear tu botiquín
          natural desde el primer día.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-164">
        {/* Visible Recipes */}
        {visibleRecipes.map((recipe, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-card rounded-2xl p-8 shadow-warm border border-sage/30 relative overflow-hidden min-h-[350px] flex flex-col" data-id="element-165">
            <h3 className="text-2xl font-playfair text-forest mb-3" data-id="element-166">
              {recipe.title}
            </h3>
            <div className="bg-parchment/50 rounded-lg p-4 mb-6 border-l-4 border-amber" data-id="element-167">
              <p className="text-brown/80 italic text-sm" data-id="element-168">
                <span className="font-semibold text-amber not-italic mr-2" data-id="element-169">
                  Para qué sirve:
                </span>
                {recipe.purpose}
              </p>
            </div>

            <div className="relative flex-grow" data-id="element-170">
              <div className="opacity-40 blur-[3px] select-none pointer-events-none" data-id="element-171">
                <h4 className="flex items-center text-lg font-playfair text-forest mb-4 border-b border-sage/20 pb-2" data-id="element-172">
                  <List className="w-5 h-5 mr-2 text-sage" data-id="element-173" /> Ingredientes
                </h4>
                <ul className="space-y-2" data-id="element-174">
                  <li className="flex items-center text-brown/90" data-id="element-175">
                    <Droplets className="w-4 h-4 mr-2 text-amber" data-id="element-176" /> Ingrediente
                    secreto 1
                  </li>
                  <li className="flex items-center text-brown/90" data-id="element-177">
                    <Droplets className="w-4 h-4 mr-2 text-amber" data-id="element-178" /> Ingrediente
                    secreto 2
                  </li>
                  <li className="flex items-center text-brown/90" data-id="element-179">
                    <Droplets className="w-4 h-4 mr-2 text-amber" data-id="element-180" /> Ingrediente
                    secreto 3
                  </li>
                </ul>
              </div>
              {/* Gradient Overlay to fade out the blurred text */}
              <div className="absolute inset-0 bg-gradient-to-b from-transparent to-card pointer-events-none" data-id="element-181"></div>
            </div>
          </motion.div>)}

        {/* Locked Recipes */}
        {lockedRecipes.map((title, idx) => <motion.div key={`locked-${idx}`} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2 + idx * 0.1
      }} className="bg-sage/5 rounded-2xl p-8 border border-sage/20 relative flex flex-col items-center justify-center text-center group min-h-[200px]" data-id="element-182">
            <div className="absolute inset-0 bg-card/40 backdrop-blur-[1px] rounded-2xl z-0" data-id="element-183"></div>
            <div className="relative z-10 flex flex-col items-center" data-id="element-184">
              <div className="w-12 h-12 bg-amber/20 rounded-full flex items-center justify-center mb-4 text-amber" data-id="element-185">
                <Lock className="w-6 h-6" data-id="element-186" />
              </div>
              <h3 className="text-xl font-playfair text-forest/80 mb-2" data-id="element-187">
                {title}
              </h3>
              <p className="text-sm text-brown/60 font-medium uppercase tracking-wider" data-id="element-188">
                Receta Bloqueada
              </p>
            </div>
          </motion.div>)}
      </div>

      <div className="text-center" data-id="element-189">
        <button onClick={scrollToPricing} className="bg-amber text-white px-10 py-4 rounded-full font-bold text-lg hover:scale-105 transition-transform shadow-lg" data-id="element-190">
          Desbloquea Todas las Recetas
        </button>
      </div>
    </SectionWrapper>;
}